<template>
    <div class="container">
        <div class="col-lg-4 col-md-6 ml-auto mr-auto">
            <form>
                <card class="card-login card-white">
                    <template slot="header">
                        <img src="img/card-primary.png" alt=""/>
                        <h1 class="card-title">Log in</h1>
                    </template>
                    <div>
                        <base-input
                            v-model="username"
                            v-validate="'required|email'"
                            :error="getError('username')"
                            name="username"
                            @keypress="enter"
                            type="email"
                            placeholder="Email"
                            addon-left-icon="envelope"
                        >
                        </base-input>
                        <base-input
                            name="password"
                            v-model="password"
                            v-validate="'required'"
                            @keypress="enter"
                            :error="getError('password')"
                            type="password"
                            placeholder="Password"
                            addon-left-icon="lock"
                        >
                        </base-input>
                        <p class="text-danger" v-if="error">
                            <strong>Error!</strong> Please check your credentials!
                        </p>
                    </div>

                    <div slot="footer">
                        <base-button type="primary" :loading="loading" v-on:click="validate" class="mb-3" size="lg"
                                     block>
                            <span>Log in</span>
                        </base-button>

                        <div class="pull-right">
                            <h6>
                                <router-link class="link footer-link" to="/forgot">
                                    Need help?
                                </router-link>
                            </h6>
                        </div>
                    </div>
                </card>
            </form>
        </div>
    </div>
</template>
<script>
import LoginForm from "../Forms/ValidationForms/LoginForm";
import axios from 'axios';

export default {
    components: {LoginForm},
    data() {
        return {
            username: '',
            password: '',
            error: false,
            loading: false,
        };
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        enter(e) {
            if (e.keyCode === 13) {
                this.validate();
            }
        },
        validate() {

            this.error = false;
            this.$validator.validateAll().then(isValid => {
                this.loading = true;
                if (isValid) {
                    this.login();
                }
            });
        },
        login: function () {
            const {username, password} = this;
            this.$store.commit('customer/resetState');
            this.$store.commit('billing/resetState');
            this.$store.commit('callroute/resetState');
            this.$store.commit('did/resetState');
            this.$store.commit('ivr/resetState');
            this.$store.commit('queue/resetState');
            this.$store.commit('sipdevice/resetState');
            this.$store.commit('voicemail/resetState');
            localStorage.removeItem('permissions')
            localStorage.removeItem('teacher')
            this.$store.dispatch('AUTH_REQUEST', {username, password}).then(() => {
                const token = localStorage.getItem('user-token');
                if (token) {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
                }
                this.$store.dispatch('customer/loadUser').then(() => {
                    this.$router.push('/dashboard');
                });
            }).catch(error => {
                this.error = true;
            }).finally(() => {
                this.loading = false;
            })
        }
    }
};
</script>
<style>
.navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
}
</style>
